<template>

<div class="home outer">

	<div class="home-capture" v-if="capturing">

		<div class="home-capture-inner">

			<button v-on:click="onCloseCaptureClick" class="home-capture-close">X</button>

			<p>Keele University would like to keep you notified of updates to the Osteoporosis Options tool and associated resources. We would also like to occasionally contact you to ask how the tool has helped your practice. If you wish to be added to our circulation list please share your email address before continuing. Thank you.</p>

			<p>Personal data will not be shared with any third parties and will only be used to support Keele University’s research activities.</p>

			<div class="check" :class="{'is-active': capture === 1}" v-on:click="capture = 1">I am happy to provide my email address.</div>

			<div class="email" v-if="capture === 1">
			
				<span>Email address</span>
				<input v-model="email" type="text" />
			
			</div>

			<div class="check" :class="{'is-active': capture === 2}" v-on:click="capture = 2">No thanks. I do not wish to provide my email address / I have already given my email address.</div>

			<button v-on:click="onProceedClick" class="home-capture-button" :class="{'is-disabled': !isValid}">Proceed</button>

		</div>

	</div>

	<com-head />

	<div class="home-content outer">

		<div class="inner">

			<template v-if="!$isPatient">

				<h1>{{ pages.home.title }}</h1>

				<p v-html="pages.home.description"></p>

				<div class="home-content-button">

					<com-button v-on:click="onEnterClick" :invert="true" :loading="loading">Enter</com-button>

				</div>

			</template>

			<template v-if="$isPatient && !patientMode">

				<h1>{{ pages.home.title }}</h1>

				<p v-html="pages.home.description"></p>

				<div class="home-patient-options">

					<div class="home-patient-option" v-on:click="patientMode = 'code'">
						<div class="home-patient-option-icon"><i class="fa-solid fa-key"></i></div>
						<div class="home-patient-option-body">
							<div class="home-patient-option-title">I have a code from my healthcare professional</div>
							<div class="home-patient-option-text">By entering the code, all the fracture risk scores, bone density results and treatment recommendations will be personalised for you.</div>
						</div>
						<div class="home-patient-option-chevron"></div>
					</div>

					<div class="home-patient-option" v-on:click="onPatientManual">
						<div class="home-patient-option-icon"><i class="fa-solid fa-pen-to-square"></i></div>
						<div class="home-patient-option-body">
							<div class="home-patient-option-title">I'd like to enter my own health information</div>
							<div class="home-patient-option-text">Enter some information about you that will enable the tool to personalise content for you.</div>
						</div>
						<div class="home-patient-option-chevron"></div>
					</div>

					<div class="home-patient-option" v-on:click="onPatientGeneric">
						<div class="home-patient-option-icon"><i class="fa-solid fa-book-open"></i></div>
						<div class="home-patient-option-body">
							<div class="home-patient-option-title">I'd like to browse general information</div>
							<div class="home-patient-option-text">Access the Osteoporosis Options tool and learn more about osteoporosis without entering personal information.</div>
						</div>
						<div class="home-patient-option-chevron"></div>
					</div>

				</div>

			</template>

			<template v-if="$isPatient && patientMode === 'code'">

				<h1>Enter your code</h1>

				<p>Your healthcare professional has provided you with a unique code. Please enter it below to access your personalised version of the Osteoporosis Options tool.</p>

				<div class="home-patient-code">

					<input type="text" v-model="code" class="home-patient-code-input" placeholder="Enter code" maxlength="8" v-on:keyup.enter="onPatientCode()" />

					<div class="home-patient-code-error" v-if="codeError">The code you entered is not valid. Please check and try again.</div>

					<div class="home-patient-code-actions">

						<com-button v-on:click="patientMode = null" :invert="false">Back</com-button>

						<com-button v-on:click="onPatientCode()" :invert="true" :loading="bridgeLoading">Continue</com-button>

					</div>

				</div>

			</template>

		</div>

	</div>

	<div class="home-logos">

		<div class="inner">

			<div class="home-content-logos">

				<img src="@/assets/logo.ros.png" />
				<img src="@/assets/logo.haywood.png" />
				<img src="@/assets/logo.keele.png" />
				<img src="@/assets/logo.nihr.png" />

			</div>

		</div>

	</div>
	
	<div class="home-foot outer">

		<div class="inner" v-html="pages.home.foot">

		</div>

	</div>

</div>

</template>

<script>

import comHead from './common/Head'
import comButton from './tool/common/Button'

export default {
	
	components: {
		'com-button': comButton,
		'com-head': comHead
	},

	data: function() {

		return {
			username: '',
			error: false,
			loading: false,
			capturing: false,
			capture: 0,
			email: '',
			patientMode: null,
			code: '',
			codeError: false,
			bridgeLoading: false
		}

	},

	created: function() {

		this.$store.commit('session/reset')
		this.$store.commit('session/validated', false)

		var code = (this.$route.params && this.$route.params.code) || (this.$route.query && this.$route.query.code)

		if (this.$isPatient && code) {
			this.code = code
			this.patientMode = 'code'
			this.onPatientCode(true)
		}

	},

	computed: {

		isValid: function() {

			return this.capture === 2 || (this.capture === 1 && this.email)

		}

	},

	methods: {

		onEnterClick: function() {

			// this.capturing = true

			this.onProceedClick()

		},

		onCloseCaptureClick: function() {

			this.loading = true

			this.$store.commit('session/reset')

			this.$store.commit('session/validated', true)

			this.$router.push({
				name: 'Create'
			})

		},

		onProceedClick: function() {

			this.loading = true

			if(this.$isPatient) {

				this.$store.commit('session/section/current', this.$store.getters['data/aid/sections/active'][0].id)

				this.$store.commit('session/validated', true)

				this.$store.commit('session/aid', true)

				this.$router.push({
					name: 'Create'
				})

			} else {

				this.$store.commit('session/reset')

				this.$store.commit('session/validated', true)

				this.$router.push({
					name: 'Create'
				})

			}

		},

		onPatientCode: function(direct) {

			if (!this.code || this.code.length < 4) {
				this.codeError = true
				return
			}

			this.bridgeLoading = true
			this.codeError = false

			this.$api.request('bridge/load', { code: this.code }).then(function(response) {

				this.$store.commit('session/values/all', response.values)
				this.$store.commit('session/recommendation', response.recommendation)
				this.$store.commit('session/patient/mode', 'prepopulated')

				var activeSections = this.$store.getters['data/aid/sections/active']
				var fallback = function(s) { return s.type !== 'entry' }

				if (direct === true) {

					// Direct link from the clinician side: land on My Bone Health / My results.
					var resultsSection = this.$_.findWhere(activeSections, { type: 'mybonehealth' }) || this.$_.find(activeSections, fallback)
					this.$store.commit('session/section/current', resultsSection.id)
					sessionStorage.setItem('ifrap_initial_subsection', 'results')

				} else {

					// Manual code entry on the home screen: land on What is Bone Health.
					var healthSection = this.$_.findWhere(activeSections, { type: 'health' }) || this.$_.find(activeSections, fallback)
					this.$store.commit('session/section/current', healthSection.id)

				}

				this.$store.commit('session/validated', true)
				this.$store.commit('session/aid', true)

				this.$router.push({ name: 'Code' })

			}.bind(this), function() {

				this.codeError = true
				this.bridgeLoading = false

			}.bind(this))

		},

		onPatientManual: function() {

			this.$store.commit('session/patient/mode', 'manual')
			this.$store.commit('session/section/current', this.$store.getters['data/aid/sections/active'][0].id)
			this.$store.commit('session/validated', true)
			this.$store.commit('session/aid', true)

			this.$router.push({ name: 'Entry' })

		},

		onPatientGeneric: function() {

			this.$store.commit('session/patient/mode', 'generic')
			var firstSection = this.$_.find(this.$store.getters['data/aid/sections/active'], function(s) { return s.type !== 'entry' })
			this.$store.commit('session/section/current', firstSection.id)
			this.$store.commit('session/validated', true)
			this.$store.commit('session/aid', true)

			this.$router.push({ name: 'Browse' })

		}

	}

}

</script>

<style scoped>

.home {
	height: 100%;
	overflow: auto;
}

.outer {
	width: 100%;
}

.inner {
	max-width: 1200px;
	width: 100%;
	margin: 0px auto;
}

.home-content {
	background: transparent linear-gradient(180deg, #55c5ff 0%, #D9F2FF 100%) 0% 0% no-repeat padding-box;
}

.is-patient .home-content {
	background: transparent linear-gradient(180deg, #ffca8d 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
}

.home-content:before {
	content: ' ';
	display: block;
	width: 1053px;
	height: 798px;
	position: absolute;
	right: 0px;
	top: -100px;
	background-image: url(~@/assets/home.bkg.png);
	background-repeat: no-repeat;
	background-size: 1053px 798px;
}

.home-content:after {
	content: ' ';
	display: block;
	width: 1022px;
    height: 708px;
    background-size: auto 726px;
	background-repeat: no-repeat;
	background-image: url(~@/assets/home.preview.png?3);
	position: absolute;
	left: calc(50% - 200px);
	top: 0px;
}

.is-mobile .home-content:after {
    content: ' ';
    display: block;
    width: 240px;
    height: 240px;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(~@/assets/home.preview.png?3);
    position: absolute;
    left: auto;
    right: -30px;
    bottom: -30px;
    top: auto;
    background-position: 100% 100%;
}

.is-patient .home-content:after {
	width: 1234px;
    height: 822px;
    top: 50px;
    left: calc(50% - 100px);
    background-size: 900px auto;
	background-image: url(~@/assets/home.preview.patient.png?2);
}

.is-mobile.is-patient .home-content:after {
	display: none;
}

.home-content .inner {
	min-height: 800px;
	padding-top: 150px;
}

.is-mobile .home-content .inner {
	padding: 30px 15px;
	min-height: auto;
}

.home-content h1 {
	color: #343434;
	font-size: 48px;
	font-weight: 700;
	position: relative;
	margin-bottom: 96px;
	width: 564px;
}

.is-mobile .home-content h1 {
	width: 100%;
	font-size: 48px;
	margin-bottom: 64px;
}

.home-content h1:after {
	content: ' ';
	display: block;
	position: absolute;
	width: 100px;
	height: 6px;
	background-color: var(--primary-color);
	left: 0px;
	bottom: -48px;
}

.is-mobile .home-content h1:after {
	bottom: -32px;
}

.home-content h2 {
	color: #343434;
	font-size: 30px;
	line-height: 36px;
	font-weight: 300;
	width: 564px;
	text-transform: uppercase;
	letter-spacing: 3px;
	margin-bottom: 64px;
	position: relative;
}

.home-content >>> p {
	max-width: 364px;
	color: #343434;
	font-size: 18px;
	line-height: 22px;
	font-weight: 300;
	margin-bottom: 32px;
}

.is-patient .home-content >>> p {
	max-width: 600px;
}

.home-logos {
	padding: 64px 0px;
}

.is-mobile .home-logos {
	padding: 32px 0px;
}

.home-content-logos {
	display: flex;
	align-items: center;
	gap: 40px;
	justify-content: flex-end;
}

.is-mobile .home-content-logos {
	gap: 20px;
	justify-content: center;
	flex-wrap: wrap;
}

.home-content-logos img {
	height: 56px;
}

.is-mobile .home-content-logos img {
	height: 40px;
}

.home-content-logos img:last-child {
	height: 34px;
}

.home-foot {
	background-color: #343434;
}

.home-foot .inner {
	padding: 32px;
}

.is-mobile .home-foot .inner {
	padding: 30px 15px;
}

.home-foot >>> p {
	color: #fff;
	font-size: 14px;
	line-height: 20px;
	font-weight: 300;
	text-align: center;
	margin-bottom: 32px;
}

.home-foot >>> p:last-child {
	margin-bottom: 0px;
}

.home-content-input {
	width: 564px;
	display: flex;
	align-items: center;
	margin-bottom: 16px;
}

.home-content-input-label {
	font-size: 20px;
	width: 120px;
	font-weight: 600;
	color: #343434;
	flex-shrink: 0;
}

.home-content-input-textbox {
	flex-grow: 1;
}

.home-content-input-textbox input {
	width: 100%;
	height: 48px;
	border-radius: 24px;
	background-color: #eee;
	padding: 0px 24px;
	font-size: 18px;
}

.home-content-input-textbox.is-error input {
	background-color: #ff7373;
	color: #fff;
}

.home-content-button {
	width: 564px;
	display: flex;
	margin-top: 80px;
	justify-content: flex-start;
}

.home-capture {
	position: fixed;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	background-color: rgba(0, 0, 0, 0.9);
	z-index: 10000;
	display: flex;
	justify-content: center;
	align-items: center;
}

.home-capture-inner {
	width: 600px;
}

.home-capture-inner p {
	font-size: 16px;
	line-height: 20px;
	color: #fff;
	margin-bottom: 20px;
}

.home-capture-inner .email {
	font-size: 16px;
	line-height: 20px;
	color: #fff;
	margin-top: 30px;
	margin-bottom: 30px;
	align-items: center;
	display: flex;
}

.home-capture-inner .email input {
	background-color: #fff;
	margin-left: 20px;
	width: 300px;
	color: #333;
	border-radius: 10px;
	height: 32px;
	padding: 0px 10px;
}

.home-capture-inner .check {
	font-size: 16px;
	line-height: 20px;
	color: #fff;
	margin-bottom: 20px;
	display: flex;
}

.home-capture-inner .check:before {
	width: 20px;
	height: 20px;
	background-color: #fff;
	color: #333;
	border-radius: 50%;
	flex-shrink: 0;
	display: block;
	margin-right: 20px;
	content: '';
	cursor: pointer;
	text-align: center;
	line-height: 22px;
	font-weight: bold;
	font-size: 12px;
}

.home-capture-inner .check.is-active:before {
	background-color: #23CFFD;
	content: '\2713';
}

.is-patient .home-capture-inner .check.is-active:before {
	background-color: #F69B3B;
}

.home-capture-button {
	padding: 0px 16px;
    height: 40px;
    border-radius: 24px;
    border: 2px solid var(--primary-color);
    font-size: 14px;
    font-weight: 700;
    display: block;
    color: #fff;
	width: 120px;
	margin: 0px auto;
	margin-top: 40px
}

.home-capture-button.is-disabled {
	opacity: 0.25;
	pointer-events: none;
}

.home-capture-button:hover {
    background-color: var(--primary-color);
}

.home-capture-close {
    background-color: var(--primary-color);
	width: 32px;
	height: 32px;
	line-height: 32px;
	font-size: 20px;
	text-align: center;
	color: #333;
	border-radius: 50%;
	right: -100px;
	top: -100px;
	position: absolute;
}

.home-patient-options {
	display: flex;
	flex-direction: column;
	margin-top: 32px;
}

.is-desktop .home-patient-options {
	max-width: 600px;
}

.home-patient-option {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	padding: 20px 24px;
	background-color: rgba(255, 255, 255, 0.8);
	border: none;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	cursor: pointer;
	text-align: left;
	transition: all 300ms ease-in-out;
	border-radius: 0;
}

.home-patient-option:first-child {
	border-radius: 16px 16px 0 0;
}

.home-patient-option:last-child {
	border-radius: 0 0 16px 16px;
	border-bottom: none;
}

.home-patient-option:hover {
	background-color: rgba(255, 255, 255, 1);
}

.home-patient-option-icon {
	width: 40px;
	height: 40px;
	flex-shrink: 0;
	margin-right: 16px;
	margin-top: 2px;
	border-radius: 50%;
	background-color: #343434;
	display: flex;
	align-items: center;
	justify-content: center;
}

.home-patient-option:hover .home-patient-option-icon {
	background-color: var(--primary-color);
}

.home-patient-option-icon i {
	color: #fff;
	font-size: 16px;
	width: 20px;
	text-align: center;
}

.home-patient-option-body {
	flex: 1;
	min-width: 0;
}

.home-patient-option-title {
	font-size: 16px;
	font-weight: 600;
	color: #343434;
	line-height: 22px;
}

.home-patient-option-text {
	font-size: 14px;
	color: #666;
	line-height: 20px;
	margin-top: 4px;
}

.home-patient-option-chevron {
	width: 10px;
	height: 10px;
	flex-shrink: 0;
	margin-left: 16px;
	align-self: center;
	border-right: 2px solid #ccc;
	border-bottom: 2px solid #ccc;
	transform: rotate(-45deg);
	transition: all 300ms ease-in-out;
}

.home-patient-option:hover .home-patient-option-chevron {
	border-color: var(--primary-color);
}

.is-mobile .home-patient-option {
	padding: 16px;
}

.is-mobile .home-patient-option-title {
	font-size: 14px;
	line-height: 20px;
}

.is-mobile .home-patient-option-text {
	font-size: 13px;
}

.home-patient-code {
	margin-top: 24px;
	max-width: 400px;
}

.home-patient-code-input {
	width: 100%;
	padding: 16px 20px;
	font-size: 24px;
	font-weight: 700;
	letter-spacing: 4px;
	text-align: center;
	text-transform: uppercase;
	border: 2px solid #ddd;
	border-radius: 12px;
	background-color: #fff;
	color: #343434;
	font-family: monospace;
	outline: none;
	transition: border-color 300ms ease-in-out;
}

.home-patient-code-input:focus {
	border-color: var(--primary-color);
}

.home-patient-code-error {
	background-color: #ee7173;
	border-radius: 8px;
	padding: 12px 16px;
	margin-top: 12px;
	color: #fff;
	font-size: 14px;
	font-weight: 600;
}

.home-patient-code-actions {
	display: flex;
	gap: 12px;
	margin-top: 20px;
}

.is-mobile .home-patient-code-input {
	font-size: 20px;
	padding: 12px 16px;
}

</style>
